/* import __COLOCATED_TEMPLATE__ from './radio-group.hbs'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@ember/component';
import { action } from '@ember/object';
let RadioGroup = (_class = class RadioGroup extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "accounts", void 0);
    _defineProperty(this, "selectAccount", void 0);
  }
  _selectAccount(event) {
    if (!event.detail.newSelection?.selected) {
      return;
    }
    const newAccountId = event.detail.newSelection.value;
    const newAccount = this.accounts.find(account => {
      return account.id === newAccountId;
    });
    if (newAccount) {
      this.selectAccount(newAccount);
    } else {
      throw new Error(`failed to lookup account ${newAccountId} to select`);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "_selectAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_selectAccount"), _class.prototype), _class);
export { RadioGroup as default };